import {
    CLEAR_LOGIN_FAILURE,
    INITIATE_LOGIN_RESET,
    LOGIN,
    LOGIN_FAILURE,
    LOGOUT,
    REGISTER_LOGIN_RESET_RESPONSE,
    SESSION_SET
} from "./authActions";

const INITIAL = {};

/**
 * `session` is `{accessToken, refreshToken}` and is only written through the auth session service
 * (SESSION_SET), which also keeps LocalStorage in step. Whether somebody is logged in is derived from it.
 */
export default function authReducer(state = INITIAL, action) {
    switch (action.type) {
        case LOGIN:
            return {...state, loginLoading: true, loginFailed: false, loginFailureReason: undefined, resetResult: undefined}
        case LOGIN_FAILURE:
            return {...state, loginLoading: false, loginFailed: true, loginFailureReason: action.payload?.reason}
        case CLEAR_LOGIN_FAILURE:
            return {...state, loginFailed: false, loginFailureReason: undefined}
        case SESSION_SET:
            return {...state, session: action.payload.session, loginLoading: false, loginFailed: false, loginFailureReason: undefined}
        case LOGOUT:
            return INITIAL
        case INITIATE_LOGIN_RESET:
            return {...state, resetResult: undefined}
        case REGISTER_LOGIN_RESET_RESPONSE:
            return {...state, resetResult: action.payload.resetResult}
        default:
            return state;
    }
}
